var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmpl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.887 24.278 16.73 2l-1.339.243C12.35 10.035 6.067 25.933 5.288 27.2 4.507 28.466 2.77 28.783 2 28.783V30h9.374v-1.217c-.446 0-1.534-.122-2.313-.61-.778-.486-.73-1.582-.608-2.069l6.696-18.139c2.15 6.209 6.476 18.821 6.574 19.6.097.78-1.745 1.136-2.678 1.218V30h10.47v-1.217c-.813-.203-2.558-.73-3.044-1.218-.487-.487-1.258-2.394-1.583-3.287z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmpl);
export default __webpack_public_path__ + "static/media/AMPL.6f85d3fb50b7d2d5f3c55b88bf5c608a.svg";
export { ForwardRef as ReactComponent };